// src/AppRoutes/ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const ProtectedRoute = ({ element }) => {
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const navigate = useNavigate();

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (!decoded.exp) return true;
      const now = Date.now() / 1000; // in seconds
      return decoded.exp < now;
    } catch (error) {
      return true; // Invalid token
    }
  };

  useEffect(() => {
    // Extract token from the URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    // Check if token exists and store it in localStorage
    if (token) {
      localStorage.setItem("authToken", token);
      navigate("/settings",{ state: { from: "login" } });
      setShouldNavigate(true);
    } else if (!authToken || isTokenExpired(authToken)) {
      localStorage.removeItem("authToken");
      // If no token, show the snackbar notification
      setSnackbarOpen(true);
    }
  }, [location.search]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  if (!authToken || isTokenExpired(authToken)) {
    // Extract query params if they exist
    const queryParams = new URLSearchParams(location.search);
    const eventId = queryParams.get("eventId");
    const eventInviteType = queryParams.get("eventInviteType");
    const redirectUrl = `${location.pathname}${location.search}`;
    localStorage.setItem("redirectUrl", redirectUrl);
    return (
      <>
        <Navigate
          to={`/login?eventId=${eventId || ""}&eventInviteType=${
            eventInviteType || ""
          }`}
          state={{ from: location }}
          replace
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="warning">
            You must log in to proceed.
          </Alert>
        </Snackbar>
      </>
    );
  }

  return element;
};

export default ProtectedRoute;
